import type { Mood } from "@obean/beans";
import { beanSvg } from "@obean/beans";

/**
 * A player's bean (ADR 0018), drawn by @obean/beans. Decorative: the name and the badges next to it
 * say the same in words, so it's hidden from screen readers. The SVG comes from the package's own
 * constants and numbers (never from what people type), so it's safe as markup.
 */
export function Bean({
  colour,
  extra = null,
  mood = "ready",
  badge,
  size,
  detail,
  class: className,
}: {
  colour: number;
  extra?: string | null;
  mood?: Mood;
  badge?: number;
  size: number;
  detail?: boolean;
  class?: string;
}) {
  return (
    <span
      class={`bean${className ? ` ${className}` : ""}`}
      aria-hidden="true"
      style={{ width: `${String(size)}px`, height: `${String(size)}px` }}
      dangerouslySetInnerHTML={{
        __html: beanSvg({
          colour,
          extra,
          mood,
          size,
          detail: detail ?? size >= 32,
          ...(badge === undefined ? {} : { badge }),
        }),
      }}
    />
  );
}

/** A member's mood from what the room already knows (ADR 0018: no protocol for moods). */
export function moodOf(m: {
  connected: boolean;
  away?: boolean;
  speaking: boolean;
  won: boolean;
}): Mood {
  if (!m.connected || m.away === true) return "reconnecting";
  if (m.speaking) return "talking";
  if (m.won) return "won";
  return "ready";
}
